import {
  FoodDetailsContent,
  FoodDetailsHeader,
  FoodDetailsInfo,
  StyledFoodDetails,
} from "./styled"
import { BackButton } from "components/Common/BackButton"
import Button from "components/Buttons/Button"
import FoodImage from "components/foodDetails/share/FoodImage"
import { useState } from "react"
import ChevronLeftBtn from "components/Icons/ChevronLeftBtn"
import { TopNavWrapper } from "components/Layouts/TopNavWrapper"
import { IAIScanOpenFoodFactFoodOption } from "model/food/types/openFoodFact.types"
import useOpenFoodFactForm from "features/food/hooks/openFoodFact/useOpenFoodFactForm"
import OpenFoodFactNameAndPortion from "components/foodDetails/share/OpenFoodFactNameAndPortion"
import OpenFoodFactDescription from "components/foodDetails/share/OpenFoodFactDescription"
import AppStyleCtaBox from "components/Common/AppStyleCtaBox"
import EditNutrientForm from "components/foodDetails/share/EditNutrientForm"
import EditableNutrientInformation from "components/foodDetails/share/EditableNutrientInformation"

interface IProps {
  onBack: () => void
  food: IAIScanOpenFoodFactFoodOption
  onEdit?: (food: IAIScanOpenFoodFactFoodOption) => void
}

const OpenFoodFactFoodOptionDetails = (props: IProps) => {
  const { onBack, food, onEdit } = props
  const { openFoodFact, onPortionChange, updateFoodAsManualNutrition } =
    useOpenFoodFactForm(food)

  const [displaySection, setDisplaySection] = useState<
    "FOOD_FORM" | "EDIT_NUTRITION_FORM"
  >("FOOD_FORM")

  const [isPortionValid, setIsPortionValid] = useState(true)

  const onPortionChangeHandler = (value: number) => {
    onPortionChange(value)
    setIsPortionValid(true)
  }

  const handleUpdateFood = () => {
    onEdit?.(openFoodFact)
    onBack()
  }

  if (displaySection === "EDIT_NUTRITION_FORM") {
    return (
      <EditNutrientForm
        onClose={() => {
          setDisplaySection("FOOD_FORM")
        }}
        meal={openFoodFact}
        onSubmit={updateFoodAsManualNutrition}
      />
    )
  }

  return (
    <StyledFoodDetails>
      <FoodDetailsContent>
        <FoodImage previewImageUrl={food.previewImageUrl}>
          <TopNavWrapper>
            <FoodDetailsHeader>
              <BackButton onClick={onBack}>
                <ChevronLeftBtn />
              </BackButton>

              <div style={{ width: 24, height: 24 }}></div>
            </FoodDetailsHeader>
          </TopNavWrapper>
        </FoodImage>

        <FoodDetailsInfo>
          <OpenFoodFactNameAndPortion
            food={openFoodFact}
            unitValue={openFoodFact.unit}
            portionValue={openFoodFact.portion}
            onPortionChange={onPortionChangeHandler}
            setIsPortionValid={setIsPortionValid}
            calories={openFoodFact.calorie}
            gram={openFoodFact.gram}
          />

          <EditableNutrientInformation
            entry={openFoodFact}
            setEditMode={() => setDisplaySection("EDIT_NUTRITION_FORM")}
          />

          <OpenFoodFactDescription />
        </FoodDetailsInfo>
      </FoodDetailsContent>

      <AppStyleCtaBox style={{ marginTop: "auto" }}>
        <Button
          disabled={!isPortionValid}
          style={{ width: "100%" }}
          $type="primary"
          onClick={handleUpdateFood}
        >
          Save
        </Button>
      </AppStyleCtaBox>
    </StyledFoodDetails>
  )
}

export default OpenFoodFactFoodOptionDetails
